import {defineStore} from "pinia/dist/pinia";

export const useApplicationStore = defineStore('ApplicationStore', {
    state() {
        return {
            categoryState: null,
            versionState: null,
            baseCookiesState: localStorage.baseCookies === 'true',
            analyticsCookiesState: localStorage.analyticsCookies === 'true',
            marketingCookiesState: localStorage.marketingCookies === 'true',
            studyInformationState: {},
            scoringForm1State: {},
            scoringForm1bState: {},
            scoringForm2aState: {},
            scoringForm2bState: {},
            scoringForm2cState: {},
            scoringForm3State: {},
            qolAdjustmentState: '-',
            adjustmentState: '-',
            adjustmentForm2aState: '-',
            adjustmentForm2bState: '-',
            adjustmentForm3State: '-'
        }
    },
    getters: {
        category() {
            return this.categoryState
        },
        version() {
            return this.versionState
        },
        studyInformation() {
            return this.studyInformationState
        },
        scoringForm1() {
            return this.scoringForm1State
        },
        scoringForm1b() {
            return this.scoringForm1bState
        },
        scoringForm2a() {
            return this.scoringForm2aState
        },
        scoringForm2b() {
            return this.scoringForm2bState
        },
        scoringForm2c() {
            return this.scoringForm2cState
        },
        scoringForm3() {
            return this.scoringForm3State
        },
        qolAdjustment() {
            return this.qolAdjustmentState
        },
        adjustment() {
            return this.adjustmentState
        },
        adjustmentForm2a() {
            return this.adjustmentForm2aState
        },
        adjustmentForm2b() {
            return this.adjustmentForm2bState
        },
        adjustmentForm3() {
            return this.adjustmentForm3State
        },
        baseCookies() {
            return this.baseCookiesState
        },
        analyticsCookies() {
            return this.analyticsCookiesState
        },
        marketingCookies() {
            return this.marketingCookiesState
        },
    },
    actions: {
        setCategory(category) {
            this.categoryState = category
        },
        setVersion(version) {
            this.versionState = version
        },
        setStudyInformation(studyInformation) {
            this.studyInformationState = studyInformation
        },
        setScoringForm1(scoring) {
            this.scoringForm1State = scoring
        },
        setScoringForm1b(scoring) {
            this.scoringForm1bState = scoring
        },
        setScoringForm2a(scoring) {
            this.scoringForm2aState = scoring
        },
        setScoringForm2b(scoring) {
            this.scoringForm2bState = scoring
        },
        setScoringForm2c(scoring) {
            this.scoringForm2cState = scoring
        },
        setScoringForm3(scoring) {
            this.scoringForm3State = scoring
        },
        setQolAdjustment(qolAdjustment) {
            this.qolAdjustmentState = qolAdjustment
        },
        setAdjustment(adjustment) {
            this.adjustmentState = adjustment
        },
        setAdjustmentForm2a(adjustment) {
            this.adjustmentForm2aState = adjustment
        },
        setAdjustmentForm2b(adjustment) {
            this.adjustmentForm2bState = adjustment
        },
        setAdjustmentForm3(adjustment) {
            this.adjustmentForm3State = adjustment
        },
        setBaseCookies(baseCookies) {
            this.baseCookiesState = baseCookies;
            localStorage.baseCookies = baseCookies;
        },
        setAnalyticsCookies(analyticsCookies) {
            this.analyticsCookiesState = analyticsCookies;
            localStorage.analyticsCookies = analyticsCookies;
        },
        setMarketingCookies(marketingCookies) {
            this.marketingCookiesState = marketingCookies;
            localStorage.marketingCookies = marketingCookies;
        },
        resetScoringForms() {
            this.scoringForm1State = {}
            this.scoringForm2aState = {}
            this.scoringForm2bState = {}
            this.scoringForm2cState = {}
            this.scoringForm3State = {}
            this.qolAdjustmentState = '-'
            this.adjustmentState = '-'
            this.adjustmentForm2aState = '-'
            this.adjustmentForm2bState = '-'
            this.adjustmentForm3State = '-'
        },
    }
})
